import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { MailX, CheckCircle } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

const Unsubscribed: React.FC = () => {
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email') || '';
  const companyName = searchParams.get('company_name') || '';
  const status = searchParams.get('status');

  const isError = status === 'error';

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="max-w-md w-full shadow-lg">
        <CardContent className="pt-8 pb-8 text-center space-y-4">
          {isError ? (
            <MailX className="h-12 w-12 text-destructive mx-auto" />
          ) : (
            <CheckCircle className="h-12 w-12 text-primary mx-auto" />
          )}

          <h1 className="text-2xl font-bold text-foreground">
            {isError ? 'Something went wrong' : "You've been unsubscribed"}
          </h1>

          {!isError && (
            <p className="text-muted-foreground">
              You will no longer receive emails
              {companyName && (
                <> from <strong className="text-foreground">{companyName}</strong></>
              )}
              .
            </p>
          )}

          {isError && (
            <p className="text-muted-foreground">
              We couldn't process your unsubscribe request. Please try again or contact support.
            </p>
          )}

          {email && (
            <p className="text-sm text-muted-foreground">
              Email: {email}
            </p>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default Unsubscribed;
